module.exports = __webpack_public_path__ + "img/建築師證照.872e488f.jpg";